
module dg.lists {

    import ListQuery = dg.domain.queries.ListQuery;
          
    class PagingCounterController {

        public constructor(
            private $document: ng.IDocumentService
        ) {
        }

        $onInit = () => {
        }

        private queryManipulator: dg.actions.ServerQueryManipulator;
        //private queryResult: any;
        //private listPagingOptions: dg.lists.IListPagingOptions;
    }

    angular.module('dg.lists').component('pagingCounter', {
        bindings: {
            queryManipulator: '<'
        },
        controller: PagingCounterController,
        templateUrl: '/digmo/src/lists/paging-counter.html'
    });
}